export type Module = {
  name: string;
  description: string;
  price: {
    upperLimit: number;
    lowerLimit: number;
    speedOfDecline?: number;
  };
  id: string;
};

const DECLINE_SPEED = 600;
const X_OFFSET = -2;

export const getPerMonth = (
  upperLimit = 0,
  lowerLimit = 0,
  count: string,
  declineSpeed = DECLINE_SPEED
): number => {
  const moduleSeats = parseInt(count);
  const seats = Number.isNaN(moduleSeats) ? 0 : moduleSeats;

  if (!seats) {
    return 0;
  }
  return (
    (upperLimit -
      (upperLimit - lowerLimit) /
        (1 + Math.exp(-seats / declineSpeed + X_OFFSET))) /
    0.95
  );
};

export const getPerYear = (
  upperLimit = 0,
  lowerLimit = 0,
  count: string,
  declineSpeed = DECLINE_SPEED
): number => {
  return 12 * 0.9 * getPerMonth(upperLimit, lowerLimit, count, declineSpeed);
};

export const modulesMap: Record<string, Module> = {
  dpf: {
    name: "Digitale Personalakte",
    id: "dpf",
    description:
      "Mit der digitalen Personalakte liegen all Ihre Daten gut geschützt an einem Ort. Unser innovativer Ansatz sorgt für fehlerfreie und jederzeit aktuelle Angaben.",
    price: {
      upperLimit: 16,
      lowerLimit: 2,
    },
  },
  absences: {
    name: "Urlaub & Abwesenheiten",
    id: "absences",
    description:
      "Behalten Sie den Überblick über alle Abwesenheiten und freuen Sie sich über clevere Automatismen, die Ihnen zahlreiche Handgriffe ersparen.",
    price: {
      upperLimit: 4,
      lowerLimit: 0.8,
    },
  },
  timeTracking: {
    name: "Zeiterfassung",
    id: "timeTracking",
    description:
      "Moderne Technik, zahlreiche Personalisierungen und smarte Funktionen machen die Zeiterfassung besonders effizient und vor allem einfach.",
    price: {
      upperLimit: 4,
      lowerLimit: 0.8,
    },
  },
  inventory: {
    name: "Inventar",
    id: "inventory",
    description:
      "Mit HeavenHR 2.0 wissen Sie nicht nur, wer Dienstwagen, Laptop und Co. besitzt, sondern haben auch automatisch die Rückgabefristen im Blick.",
    price: {
      upperLimit: 2,
      lowerLimit: 0.4,
    },
  },
  templateGenerator: {
    name: "Dokumentengenerator",
    id: "templateGenerator",
    description:
      "Generieren Sie neue Dokumente und Vorlagen oder laden Sie bestehende Dateien im Generator hoch. Sie entscheiden, wer wann welches Dokument sehen kann.",
    price: {
      upperLimit: 3,
      lowerLimit: 0.5,
    },
  },
  reporting: {
    name: "Reporting",
    id: "reporting",
    description:
      "Mit HeavenHR 2.0 bauen Sie ganz einfach individuelle Berichte mit allen relevanten Kennzahlen, um daraus wichtige Handlungsempfehlungen zu erkennen.",
    price: {
      upperLimit: 5,
      lowerLimit: 0.8,
    },
  },
  onBoarding: {
    name: "On- & Offboarding",
    id: "onBoarding",
    description:
      "Erstellen Sie schnell und einfach Aufgaben und weisen Sie diese Mitarbeitern zu. Mit unseren smarten Templates sind Sie sogar noch effizienter.",
    price: {
      upperLimit: 1.5,
      lowerLimit: 0.4,
    },
  },
  eAu: {
    name: "eAU-Abfrage-Service",
    id: "eAu",
    description:
      "HeavenHR 2.0 fragt die eAU für Sie ab und hinterlegt sie im Abwesenheitsantrag des Mitarbeiters. Sie müssen nichts weiter tun als einmal zu klicken.",
    price: {
      upperLimit: 1,
      lowerLimit: 0.2,
    },
  },
  preparatoryPayroll: {
    name: "Vorbereitende Lohnabrechnung",
    id: "preparatoryPayroll",
    description:
      "Alle relevanten Informationen für Ihre Lohnabrechnung werden für Sie in Exportdokumenten bereitgestellt. Die vorbereitende Lohnabrechnung ist somit im Handumdrehen erledigt.",
    price: {
      upperLimit: 3,
      lowerLimit: 0.9,
    },
  },
  fullPayroll: {
    name: "Komplette Lohnabrechnung",
    id: "fullPayroll",
    description:
      "Unser kompetentes Lohnabrechnungsteam kümmert sich um Ihre gesamte Abrechnung, damit Sie mehr Zeit für andere Aufgaben haben.",
    price: {
      upperLimit: 37.9,
      lowerLimit: 9,
      speedOfDecline: 800,
    },
  },
};

export const modules: Array<Module> = Object.values(modulesMap);
